export default {"src":"/_next/static/media/finder-award-2023.9e173cd9.svg","height":1080,"width":1080};